export const TOGGLE_NOTIFICATION = "TOGGLE_NOTIFICATION";

export const toggleNotification = (value) => {
	return (dispatch) => {
		return dispatch({ type: TOGGLE_NOTIFICATION, payload: value });
	};
};
